/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Import_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Import progress" |
*
* @param {Iconik_Import_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_import_progress_label = /** @type {((inputs?: Iconik_Import_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Import_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de l'importation")
	if (locale === "de") return /** @type {LocalizedString} */ ("Importfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzamento dell'importazione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("ход импорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de la importación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导入进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("インポートの進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आयात प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso da importação")
	return /** @type {LocalizedString} */ ("Import progress")
});